import React, { useMemo } from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { isNumber, isBoolean } from 'lodash';

import Tooltip from '../../../../../../../../components/Tooltip';

import * as types from '../../reducer/constants';
import { getNumberValue, getProviderFormService } from '../../helper';
import ProviderInput from '../../../../../../../../components/Inputs/ProviderInput';
import { getSyncModeMin } from '../MinMax/helper';
import { getProvider } from '../../../../../helpers/getters';

const FieldIncrement = ({ form, providerForm, isLoadingProvider, errorProvider, dispatchServiceData }) => {
  const { provider_id, provider_service_id, auto_increment, increment } = form;
  const provider = useMemo(() => getProvider(provider_id), [provider_id]);
  const service = useMemo(() => getProviderFormService(provider_service_id, providerForm), [provider_service_id, providerForm]);
  const incrementValue = isNumber(increment) ? increment : '';
  const syncIncrement = service ? (service.service_increment === 0 ? '0' : service.service_increment) : false;
  const syncModeIncrement = useMemo(
    () => getSyncModeMin(provider, service, errorProvider, isLoadingProvider),
    [provider, service, errorProvider, isLoadingProvider],
  );
  const onChangeDispatch = (value) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_INCREMENT, value })
  }

  const onChange = (e) => {
    const value = e.target.value;
    const refillDayValue = getNumberValue(value);
    if (!isBoolean(refillDayValue)) {
      onChangeDispatch(refillDayValue);
    }
  };

  const onChangeSyncIncrement = (value) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_INCREMENT, value });
    /**
     * Если включечена синхронизации
     * кастомный increment убираем
     * Если выключена
     * в кастомный increment вставляем от провайдера
     */
    if (value) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_INCREMENT, value: null });
    } else {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_INCREMENT, value: syncIncrement });
    }
  };

  return (
    <>
      <FormGroup>
        <ControlLabel htmlFor="increment">
          Increment
          {' '}
          <Tooltip
            placement="top"
            text={(
              <p>
                Restriction to accept quantity
                <br />
                {' '}
                multiple of setted value
              </p>
            )}
            tooltipClass="tooltip__top"
          >
            <span className="fas fa-info-circle cursor-help" />
          </Tooltip>
        </ControlLabel>
        <ProviderInput
          name="increment"
          required={false}
          syncMode={syncModeIncrement}
          syncValue={service && auto_increment}
          providerValue={syncIncrement}
          onChange={onChange}
          onChangeSync={onChangeSyncIncrement}
          value={incrementValue}
        />
      </FormGroup>
    </>
  );
};

FieldIncrement.propTypes = {
  form: PropTypes.object,
  providerForm: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isLoadingProvider: PropTypes.bool,
  errorProvider: PropTypes.string,
  dispatchServiceData: PropTypes.func,
}

export default FieldIncrement;
